import * as angular from 'angular';

import { AuthOptionsService } from './auth-options/auth-options.service';

/* prettier-ignore */
export const CommonModule = angular
  .module('sign-in.common', [])
  .service('AuthOptionsService', AuthOptionsService)
  .name;
